import Cookies from 'js-cookie'

import { COOKIE_NAMES } from 'lib/constants'

/**
 * We use a cookie to track internal users. This is set in the cc-cloud package.
 * Currently the main thing we use it for is to suppress Segment events for
 * internal users of the prod site.
 */
export const getIsInternalUser = (): boolean =>
  Cookies.get(COOKIE_NAMES.isInternalUser) === 'true'
